import { render } from "./PersonLight.vue?vue&type=template&id=199ef4a1&scoped=true"
import script from "./PersonLight.vue?vue&type=script&lang=js"
export * from "./PersonLight.vue?vue&type=script&lang=js"

import "./PersonLight.vue?vue&type=style&index=0&id=199ef4a1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199ef4a1"]])

export default __exports__